<div class="mat-typography dialog-container layout-col">
  <!-- header -->
  <div
    mat-dialog-title
    class="layout-row layout-wrap layout-align-space-between-center gap-12 mat-mdc-dialog-title"
  >
    <!-- left -->
    <div class="layout-row layout-align-start-center gap-12">
      <h1 [ngSwitch]="mode" class="no-margin">
        <span *ngSwitchCase="'insert'">Inserisci task</span>
        <span *ngSwitchCase="'insertByAV'">Inserisci task</span>
        <span *ngSwitchCase="'edit'">Modifica task</span>
        <span *ngSwitchCase="'view'">Dettagli task</span>
        <span *ngSwitchDefault>Task</span>
      </h1>
    </div>

    <!-- right -->
    <div class="layout-row layout-align-end-center gap-12">
      <!-- edit mode -->
      <button
        mat-flat-button
        *ngIf="data.task && !isAI"
        (click)="editMode = !editMode"
        [color]="editMode ? '' : 'accent'"
      >
        <div class="layout-row layout-align-center-center gap-12">
          <span>{{ !editMode ? "Abilita" : "Disabilita" }} modifica</span>
          <mat-icon [svgIcon]="editMode ? 'pencil-off' : 'pencil'"></mat-icon>
        </div>
      </button>

      <!-- close -->
      <button mat-icon-button mat-dialog-close>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>

  <!-- content -->
  <div mat-dialog-content>
    <!-- form -->
    <c3-form-task
      [mode]="mode"
      [item]="data.task"
      [context]="data.context"
      [AIFlag]="isAI"
      #formItem
    >
    </c3-form-task>
  </div>

  <!-- actions -->
  <div mat-dialog-actions class="actions-box layout-row layout-align-space-between-center gap-12">
    <div class="layout-row layout-align-start-center gap-12">
      <app-form-valid-tick [formValid]="formItem.form.valid" [formTouched]="formItem.form.touched">
      </app-form-valid-tick>
    </div>

    <div class="layout-row layout-align-end-center gap-12" style="margin-left: auto">
      <!-- submit button -->
      <ion-spinner *ngIf="loading$ | async" color="secondary"></ion-spinner>

      <ion-buttons slot="end" class="ion-margin-end">
        <ion-button
          type="submit"
          *ngIf="editMode"
          [disabled]="
            !editMode || formItem.form.invalid || formItem.form.pristine || (loading$ | async)
          "
          color="secondary"
          (click)="onSubmit(formItem)"
        >
          <ion-icon slot="start" [src]="'content-save' | getIcon"></ion-icon>
          <span>Salva</span>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
</div>
